import type { FallbackProps } from 'react-error-boundary';

import { Button } from '@/components/ui/button';

const SMC_LOGO_URL = '/smc-logo.svg';

const ErrorFallback = ({ error }: FallbackProps) => (
  <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-8">
    <div className="w-full max-w-md space-y-8 rounded-2xl bg-white p-10 shadow-2xl">
      <div className="flex flex-col items-center space-y-6 text-center">
        <img
          alt="Star Mountain Capital"
          className="h-[60px] w-auto"
          src={SMC_LOGO_URL}
        />
        <div className="space-y-3">
          <h1 className="text-2xl font-semibold text-gray-900">
            Something Unexpected Happened
          </h1>
          <p className="text-sm text-gray-600">
            We've been notified and are looking into it. Please try refreshing
            the page.
          </p>
        </div>
        <Button
          className="w-full"
          onClick={() => {
            window.location.reload();
          }}
          size="lg"
        >
          Refresh Page
        </Button>
        {error instanceof Error && process.env.NODE_ENV === 'development' && (
          <details className="w-full text-left">
            <summary className="cursor-pointer text-sm text-gray-500">
              Technical Details
            </summary>
            <pre className="mt-2 rounded bg-gray-100 p-3 text-xs break-all whitespace-pre-wrap text-gray-700">
              {error.message}
            </pre>
          </details>
        )}
      </div>
    </div>
  </div>
);

export default ErrorFallback;
